import { render, staticRenderFns } from "./AmountComponent.vue?vue&type=template&id=1db53b7a&scoped=true&"
import script from "./AmountComponent.vue?vue&type=script&lang=js&"
export * from "./AmountComponent.vue?vue&type=script&lang=js&"
import style0 from "./AmountComponent.vue?vue&type=style&index=0&id=1db53b7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db53b7a",
  null
  
)

export default component.exports